import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixTabs from "@radix-ui/react-tabs";
import classNames from "classnames";
export const Tabs = (param)=>{
    let { activationMode, className, defaultValue, dir, listClassName, loop, onValueChange, orientation, panels = [], panelsClassName, rightControls, ...rest } = param;
    var _panels_;
    const defaultTab = defaultValue || (panels === null || panels === void 0 ? void 0 : (_panels_ = panels[0]) === null || _panels_ === void 0 ? void 0 : _panels_.id);
    return /*#__PURE__*/ _jsxs(RadixTabs.Root, {
        activationMode: activationMode,
        className: className,
        defaultValue: defaultTab,
        dir: dir,
        onValueChange: onValueChange,
        orientation: orientation,
        ...rest,
        children: [
            /*#__PURE__*/ _jsxs(RadixTabs.List, {
                className: tailwindMerge("flex justify-between border-b border-b-grey-5", listClassName),
                loop: loop,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-5",
                        children: panels === null || panels === void 0 ? void 0 : panels.map((panel)=>/*#__PURE__*/ _jsx(RadixTabs.Trigger, {
                                className: classNames("group/tabs-trigger -mb-px cursor-pointer select-none border-b-2 border-t-2 border-b-transparent border-t-transparent text-12 font-semibold text-grey-12 radix-disabled:cursor-not-allowed radix-disabled:opacity-45 radix-state-active:border-b-blue-9 radix-state-active:text-grey-12", panel.labelClassName),
                                disabled: panel.disabled,
                                value: panel.id,
                                "data-testid": "TAB_TRIGGER",
                                "data-tabid": panel.id,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "-mx-2 mb-1 flex items-center gap-1 rounded bg-transparent px-2 py-1 group-hover/tabs-trigger:bg-grey-4 group-active/tabs-trigger:bg-grey-4",
                                    children: panel.label
                                })
                            }, panel.id))
                    }),
                    rightControls
                ]
            }),
            panels === null || panels === void 0 ? void 0 : panels.map((panel)=>/*#__PURE__*/ _jsx(RadixTabs.Content, {
                    className: classNames(panelsClassName, panel.contentClassName),
                    value: panel.id,
                    children: panel.content
                }, panel.id))
        ]
    });
};
